const baseURL = process.env.REACT_APP_BASE_URL;
const imageURL = process.env.REACT_APP_IMAGE_URL;

module.exports = {
  baseURL,
  imageURL
};



// WEBPACK FOOTER //
// ./src/constants/index.js